module.exports = __webpack_public_path__ + "img/43.49844549.jpg";